export async function registerShell(onUpdate) {
  if (!('serviceWorker' in navigator) || !isSecureContext) return { status: 'unsupported' };
  const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  const offer=()=>{if(registration.waiting)onUpdate(()=>registration.waiting?.postMessage({type:'ACTIVATE_SHELL'}));};
  offer();registration.addEventListener('updatefound',()=>{const worker=registration.installing;worker?.addEventListener('statechange',()=>{if(worker.state==='installed'&&navigator.serviceWorker.controller)offer();});});
  return { status: 'registered', registration };
}
